// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2nZs8","video":"_3vNBa"};